import { FilterOption } from '~/app/features/Gallery/components/Filters/FilterOption'
import type { RenderableFilterOption } from 'shared/types/util'
import { SingleSelectFilter } from '~/app/features/Gallery/components/Filters/SingleSelect'
import type { State } from 'shared/types/gallery/state'

export interface PropTypes {
  filter: State.Filter
}

export const RadioFilter = (props: PropTypes) => {
  const { filter } = props

  return (
    <SingleSelectFilter filter={filter as State.AttributeFilter}>
      {(o: RenderableFilterOption) => <FilterOption facetCount={o.facetCount} title={o.title} />}
    </SingleSelectFilter>
  )
}

RadioFilter.displayName = 'RadioFilter'
